import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { grantAnalyticsConsent } from '../../utils/analytics';

const CONSENT_KEY = 'cookie_consent';

type ConsentChoice = 'accepted' | 'necessary_only';

export default function CookieConsent() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const stored = localStorage.getItem(CONSENT_KEY);
        if (!stored) {
            // Show banner after a short delay so it doesn't flash on load
            const timer = setTimeout(() => setVisible(true), 1500);
            return () => clearTimeout(timer);
        }
        // If user previously accepted, grant consent on load
        if (stored === 'accepted') {
            grantAnalyticsConsent();
        }
    }, []);

    const handleAcceptAll = () => {
        localStorage.setItem(CONSENT_KEY, 'accepted' as ConsentChoice);
        grantAnalyticsConsent();
        setVisible(false);
    };

    const handleNecessaryOnly = () => {
        localStorage.setItem(CONSENT_KEY, 'necessary_only' as ConsentChoice);
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div data-client-only className="fixed bottom-0 left-0 right-0 z-[9999] px-4 pb-4 animate-fade-in">
            <div className="max-w-3xl mx-auto bg-cosmic-900 border border-divine/30 rounded-xl shadow-2xl p-5 sm:p-6">
                <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                    <div className="flex-1 text-sm text-gray-300 leading-relaxed">
                        <p>
                            We use cookies to improve your experience. Essential cookies keep the site
                            running (authentication, payments). Analytics cookies help us understand
                            how you use the site.{' '}
                            <Link to="/privacy" className="text-divine underline hover:text-divine-200">
                                Privacy Policy
                            </Link>
                        </p>
                    </div>
                    <div className="flex gap-3 shrink-0">
                        <button
                            onClick={handleNecessaryOnly}
                            className="px-4 py-2 text-sm text-gray-300 border border-gray-600 rounded-lg hover:border-gray-400 hover:text-white transition-colors"
                        >
                            Necessary Only
                        </button>
                        <button
                            onClick={handleAcceptAll}
                            className="px-4 py-2 text-sm bg-divine text-white rounded-lg hover:bg-divine-600 transition-colors font-medium"
                        >
                            Accept All
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
